import React, { useState } from "react";
import SEO from /*'../../common/SEO'*/ "../../../src/common/SEO";
import Layout from "../../../src/common/Layout";
import BreadcrumbOne from "../UniversityPage/UK/BreadcrumbOne";
import UniversitiesCourse from "../UniversityPage/UK/UniversitiesCourse";
import UniversityData from "../UniversityPage/UK/UniversityData.json";
import PaginationOne from "../../../src/components/pagination/PaginationOne";
import SearchOne from "../../../src/components/widgets/blog/SearchOne";
import UniversitiesFilter from "../UniversityPage/UK/UniversitiesFilter";
import { useFilterContext } from "../UniversityPage/UK/filter_context";
import Main from "../../sections/Main.json";
import { useSelector } from "react-redux";
import {
  Box,
  Button,
  ButtonBase,
  Card,
  CardContent,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

const AppNewApplicationApp = () => {
  const [Country, setCountry] = useState(null);
  const [Intake, setIntake] = useState(null);
  const [CourseType, setCourseType] = useState(null);
  const [University, setUniversity] = useState(null);
  const [Course, setCourse] = useState(null);
  const navigate = useNavigate();

  // const intakes = useSelector(({ addNewApplicationApp }) => addNewApplicationApp.getIntakes)
  // console.log(intakes);

  // const country = useSelector(({ addNewApplicationApp }) => addNewApplicationApp.getCountry)

  const [uk, setUk] = useState(false);
  const [ukClicked, setUkClicked] = useState(false);

  const [us, setUs] = useState(false);
  const [usClicked, setUsClicked] = useState(false);

  const [ind, setind] = useState(false);
  const [indClicked, setIndClicked] = useState(false);

  var cardStyle1 = {
    display: "flex",
    width: "120px",
    transitionDuration: "0.3s",
    height: "120px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: uk ? "#603aa2" : "#c59bdb60",
    color: "white",
  };
  var cardStyle2 = {
    display: "flex",
    width: "120px",
    transitionDuration: "0.3s",
    height: "120px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: us ? "#603aa2" : "#c59bdb60",
  };
  var cardStyle3 = {
    display: "flex",
    width: "120px",
    transitionDuration: "0.3s",
    height: "120px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: ind ? "#603aa2" : "#c59bdb60",
  };

  const handleClickUk = () => {
    if (ukClicked == false) {
      setUk(true);
      setUkClicked(true);

      setUs(false);
      setUsClicked(false);
      setind(false);
      setIndClicked(false);

      setIntake(true);
      setCourseType(true);
      setUniversity(true);
      setCourse(true);
      console.log("Uk");
    } else {
      setUk(false);
      setUkClicked(false);
      setUs(false);
      setUsClicked(false);
      setind(false);
      setIndClicked(false);
    }
  };

  const handleClickUs = () => {
    if (usClicked == false) {
      setUs(true);
      setUsClicked(true);

      setUk(false);
      setUkClicked(false);
      setind(false);
      setIndClicked(false);
      setIntake(true);
      setCourseType(true);
      setUniversity(true);
      setCourse(true);
      console.log("US");
    } else {
      setUk(false);
      setUkClicked(false);
      setUs(false);
      setUsClicked(false);
      setind(false);
      setIndClicked(false);
    }
  };

  const handleClickInd = () => {
    if (indClicked == false) {
      setind(true);
      setIndClicked(true);

      setUk(false);
      setUkClicked(false);
      setUs(false);
      setUsClicked(false);
      setIntake(true);
      setCourseType(true);
      setUniversity(true);
      setCourse(true);
      console.log("Ind");
    } else {
      setUk(false);
      setUkClicked(false);
      setUs(false);
      setUsClicked(false);
      setind(false);
      setIndClicked(false);
    }
  };

  const handleSelectedCountry = (e) => {
    setCountry(e.target.value);
  };

  const handleSelectedIntake = (e) => {
    setIntake(e.target.value);
  };

  const handleSelectedCourseType = (e) => {
    setCourseType(e.target.value);
  };

  const handleSelectedUniversity = (e) => {
    setUniversity(e.target.value);
  };

  const handleSelectedCourse = (e) => {
    setCourse(e.target.value);
  };

  const handleClickData = () => {
    let Data = new Array(1).fill({
      Intake: Intake,
      CourseType: CourseType,
      University: University,
      Course: Course,
    });
    console.log(Data);
    setIntake("");
    setCourseType("");
    setUniversity("");
    setCourse("");

    navigate("/selectdegree");
  };

  console.log(Intake, CourseType, University, Course);
  return (
    <>
      <SEO title="University" />
      <Layout>
        <div className="edu-course-area edu-section-gap bg-color-white rishabhCSSBackground">
          <div className="container">
            <div className=" grid h-screen place-items-center">
              <div className="flex flex-col h-screen place-items-center justify-center countryPicker">
                <Typography
                  color="secondary"
                  fontSize={28}
                  align="center"
                  className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry"
                >
                  Which Country do you wish to pursue your education in?
                </Typography>
                <div className="d-flex justify-center mb-20 mt-5 crad">
                  <Card
                    className="mx-20 bg-[#c59bdb60] cardSpacing"
                    style={cardStyle1}
                    onClick={handleClickUk}
                  >
                    <ButtonBase>
                      <CardContent>
                        <div className="">
                          <center>
                            <img
                              className="h-60 w-60 rounded-full"
                              src="/customizedimages/ukflag.jpg"
                              alt="Ukflag"
                            />
                            <Typography
                              style={{
                                color: uk ? "white" : "#5D3FD3",
                                fontSize: "18px",
                                marginTop: "15%",
                              }}
                              className="font-bold mt-10 text-10 flex justify-center  text-[#5D3FD3]"
                            >
                              UK
                            </Typography>
                          </center>
                        </div>
                      </CardContent>
                    </ButtonBase>
                  </Card>

                  <Card
                    style={cardStyle2}
                    className="bg-[#c59bdb60] cardSpacing"
                    onClick={handleClickUs}
                  >
                    <ButtonBase>
                      <CardContent>
                        <div className="content-center">
                          <center>
                            <img
                              className="w-60 h-60 rounded-full "
                              src="/customizedimages/usaflag.jpg"
                            />
                            <Typography
                              style={{
                                color: us ? "white" : "#5D3FD3",
                                fontSize: "18px",
                                marginTop: "15%",
                              }}
                              className="font-bold mt-10 text-10 flex justify-center text-[#5D3FD3]"
                            >
                              USA
                            </Typography>
                          </center>
                        </div>
                      </CardContent>
                    </ButtonBase>
                  </Card>

                  <Card
                    className="mx-20 bg-[#c59bdb60] cardSpacing"
                    style={cardStyle3}
                    onClick={handleClickInd}
                  >
                    <ButtonBase>
                      <CardContent>
                        <div>
                          <center>
                            {" "}
                            <img
                              className="w-60 h-60 rounded-full "
                              src="/customizedimages/india.jpg"
                            />
                            <Typography
                              style={{
                                color: ind ? "white" : "#5D3FD3",
                                fontSize: "18px",
                                marginTop: "15%",
                              }}
                              className="font-bold mt-10 text-10 flex justify-center text-[#5D3FD3]"
                            >
                              India
                            </Typography>
                          </center>
                        </div>
                      </CardContent>
                    </ButtonBase>
                  </Card>
                </div>
                <div className="d-flex mt-5 items-center  justify-center crad">
                  <Button
                    className="mx-8 ml-20"
                    variant="contained"
                    //  color='primary'
                    style={{ backgroundColor: "#603aa2", fontSize: "20px" }}
                    onClick={handleClickData}
                    disabled={Intake && CourseType && University ? false : true}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default AppNewApplicationApp;
